<div aria-label="unauthorized access page">
    <header class="b-top border-xl core-water-leaf-border">
        <img width="200px" [src]="logoPath" />
    </header>
    <f-divider color="neutral-mountain-mist"/>
    <div class="main">
        <div class="unauthorized-container">
            <h4 class="unauthorized-title">Access Not Provisioned</h4>
            <p class="unauthorized-message">
                Alight Worklife Insights (AWI) Cross&#8209;Client Reporting is restricted to approved ARAP security groups.
                Contact your manager to confirm eligibility and submit an access request via Saviynt.
            </p>
        </div>
    </div>
</div>
